<template>
  <v-dialog :value="open" @click:outside="closeDialog()" scrollable max-width="500">
    <ValidationObserver ref="campaignsFormObs" v-slot="{ handleSubmit }">
      <v-card :loading="isLoading">
        <v-card-title class="pa-0 shadow-1">
          <v-img
            :src="require('@/assets/illustrations/bg_modal_card.svg')"
            cover
            position="left bottom"
            class="align-center"
            height="65px"
          >
            <v-card-title class="font-weight-medium primary--text">
              {{ EditMode ? "Actualizar" : "Crear" }} Campaña
            </v-card-title>
          </v-img>
        </v-card-title>

        <vuescroll
          :ops="{
            bar: { background: '#bacfcec0', keepShow: true },
          }"
        >
          <v-card-text style="max-height: 570px">
            <v-form>
              <v-row dense>
                <!-- Nombre -->
                <v-col cols="12">
                  <ValidationProvider name="Nombre" rules="required" v-slot="{ errors }">
                    <v-text-field
                      filled
                      rounded
                      class="rounded-small"
                      dense
                      label="Nombre"
                      type="text"
                      color="blue-grey"
                      v-model="formData.name"
                      :error-messages="errors"
                    >
                    </v-text-field>
                  </ValidationProvider>
                </v-col>

                <!-- Fecha de Inicio -->
                <v-col cols="12">
                  <v-menu v-model="startDateMenu" transition="scale-transition" offset-y min-width="auto">
                    <template
                      v-slot:activator="{
                        on,
                        attrs,
                      }"
                    >
                      <ValidationProvider name="Fecha de inicio" rules="required" v-slot="{ errors }">
                        <v-text-field
                          v-model="formData.start_date"
                          label="Fecha de inicio"
                          class="rounded-small"
                          readonly
                          filled
                          required
                          rounded
                          v-bind="attrs"
                          v-on="on"
                          :error-messages="errors"
                        ></v-text-field>
                      </ValidationProvider>
                    </template>
                    <v-date-picker
                      v-model="formData.start_date"
                      no-title
                      scrollable
                      @input="startDateMenu = false"
                    ></v-date-picker>
                  </v-menu>
                </v-col>

                <!-- Fecha de fin -->
                <v-col cols="12">
                  <v-menu v-model="endDateMenu" transition="scale-transition" offset-y min-width="auto">
                    <template
                      v-slot:activator="{
                        on,
                        attrs,
                      }"
                    >
                      <ValidationProvider name="Fecha de fin" rules="required" v-slot="{ errors }">
                        <v-text-field
                          v-model="formData.end_date"
                          label="Fecha de fin"
                          class="rounded-small"
                          readonly
                          filled
                          required
                          rounded
                          v-bind="attrs"
                          v-on="on"
                          :error-messages="errors"
                        ></v-text-field>
                      </ValidationProvider>
                    </template>
                    <v-date-picker
                      v-model="formData.end_date"
                      no-title
                      scrollable
                      @input="endDateMenu = false"
                    ></v-date-picker>
                  </v-menu>
                </v-col>
                <!-- Especialidad -->
                <v-col cols="12">
                  <ValidationProvider name="Especialidad" rules="" v-slot="{ errors }">
                    <v-autocomplete
                      filled
                      rounded
                      :loading="isLoadingSpecialties"
                      class="rounded-small"
                      dense
                      label="Especialidad"
                      :items="specialtiesList"
                      item-text="name"
                      item-value="id"
                      color="blue-grey"
                      v-model="formData.specialty_id"
                      :error-messages="errors"
                    ></v-autocomplete>
                  </ValidationProvider>
                </v-col>

                <!-- Responsable -->
                <v-col cols="12">
                  <ValidationProvider name="Responsable" rules="" v-slot="{ errors }">
                    <v-autocomplete
                      filled
                      rounded
                      :disabled="!formData.specialty_id"
                      :loading="isLoadingResponsible"
                      class="rounded-small"
                      dense
                      label="Responsable"
                      :items="responsibleList"
                      item-text="name"
                      item-value="id"
                      color="blue-grey"
                      v-model="formData.responsible_id"
                      :error-messages="errors"
                    ></v-autocomplete>
                  </ValidationProvider>
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>
        </vuescroll>

        <v-divider></v-divider>

        <v-card-actions class="mx-2">
          <v-spacer></v-spacer>
          <v-hover v-slot:default="{ hover }">
            <v-btn text rounded class="mr-1" :color="hover ? 'error' : 'grey'" @click="closeDialog()">Cancelar</v-btn>
          </v-hover>

          <v-hover v-slot:default="{ hover }">
            <v-btn
              rounded
              :loading="isLoading"
              :disabled="isLoading"
              color="success"
              :class="hover ? 'shadow-2' : 'shadow-4'"
              class="px-8"
              @click.stop="handleSubmit(submitForm)"
            >
              {{ EditMode ? "Guardar" : "Crear" }}
            </v-btn>
          </v-hover>
        </v-card-actions>
      </v-card>
    </ValidationObserver>
  </v-dialog>
</template>

<script>
import vuescroll from "vuescroll";
import { PbxHttpClient } from "@/services/httpclient";

export default {
  components: { vuescroll },
  props: {
    open: {
      type: Boolean,
    },
    editData: {
      type: Object,
    },
  },
  data() {
    return {
      isLoading: false,
      isLoadingTemplates: false,
      isLoadingContacts: false,
      isLoadingSpecialties: false,
      isLoadingResponsible: false,
      startDateMenu: false,
      endDateMenu: false,
      templateList: [],
      contactList: [],
      specialtiesList: [],
      responsibleList: [],
      formData: {
        name: "",
        start_date: "",
        end_date: "",
        responsible_id: null,
        specialty_id: null,
      },
    };
  },

  computed: {
    EditMode() {
      return !!this.editData;
    },
    User() {
      return this.$store.getters["passport/CURRENT_USER"];
    },
    SpecialtyId() {
      return this.formData.specialty_id;
    },
  },

  watch: {
    open(val) {
      if (val) {
        if (this.editData) {
          const { name, start_date, end_date, specialty_id, responsible_id } = this.editData;
          this.formData = { name, start_date, end_date, specialty_id, responsible_id };
        }
      } else {
        this.formData = {
          name: "",
          start_date: "",
          end_date: "",
          responsible_id: null,
          specialty_id: null,
        };
      }
    },

    SpecialtyId(val) {
      if (val) this.getResponsibleBySpecialty();
    },
  },

  created() {
    this.getSpecialties();
  },

  methods: {
    closeDialog(item) {
      this.$emit("dialog:close", item);
      this.$refs.campaignsFormObs.reset();
    },

    async getSpecialties() {
      this.isLoadingSpecialties = true;
      try {
        const { data } = await PbxHttpClient.get("/module_appointment/specialties_select");
        this.specialtiesList = data;
      } catch (error) {
        console.log(error);
      }
      this.isLoadingSpecialties = false;
    },

    async getResponsibleBySpecialty() {
      if (!this.formData.specialty_id) return;
      this.isLoadingResponsible = true;
      try {
        const { data } = await PbxHttpClient.get(
          `/module_appointment/specialties/${this.formData.specialty_id}/responsibles`,
        );
        this.responsibleList = data;
      } catch (error) {
        console.log(error);
      }
      this.isLoadingResponsible = false;
    },

    async submitForm() {
      this.isLoading = true;
      let savedData;
      try {
        if (this.EditMode) {
          const { id } = this.editData;
          const { data } = await PbxHttpClient.put(`/module_appointment/send-appointments/${id}`, this.formData);
          savedData = data;
          this.$snotify.success("Campaña actualizada con exito", "¡Hecho!");
        } else {
          const { data } = await PbxHttpClient.post("/module_appointment/send-appointments", this.formData);
          savedData = data;
          this.$snotify.success("Campaña creada con exito", "¡Hecho!");
        }
        this.closeDialog(savedData);
      } catch (err) {
        const message = err.response.data.error;
        this.$snotify.error(message || "Hubo un error guardando la Campaña", "¡Error!");
      }
      this.isLoading = false;
    },
  },
};
</script>

<style>
.v-time-picker-custom .v-picker__title {
  height: 84px;
  padding-top: 10px;
}
</style>
